import { defa } from 'defa-object';
/**
 * defa.models.SubscriptionPackage
 * The DEFA SubscriptionPackage model.
 * @version 1.2.0
 */
import Model    from 'scripts/poppet/model';

const channel = Bb.Radio.channel( 'objects' );

const api = {
	subscriptionPackages: defa.vars.apiHost + '/subscriptionpackages',
};

const SubscriptionPackage = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	urlRoot: api.subscriptionPackages,
	
	defaults: {
		fixedPrice     : !1,
		monthlyPrice   : '',
		packagePrice   : '',
		promotionCode  : '',
		registrationFee: '',
		renewable      : true,
		
		transientFree				   : false,
		transientNextPaymentStateChange: '',
		transientName                  : '',
		transientFormatMonthlyPrice    : '',
		transientFormatYearlyPrice     : '',
		transientFormatRegistrationFee : '',
		transientFormatPackagePrice    : '',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * While parsing, also add itself to the channel collection.
	 * @param  {object} response  The response object from the server to make the model from.
	 * @return {object}           The parsed response object to make the model from.
	 */
	parse: function ( response ) {
		channel.request( 'subscriptionPackages' ).add( response, { merge: true } );
		
		return response;
	},
	
} );

export default SubscriptionPackage;